export default "__VITE_ASSET__C1mLN$p0__"